/*

Ajax Load More callbacks

https://connekthq.com/plugins/ajax-load-more/docs/callback-functions

*/

// almDone() is dispatched after all posts have been loaded and there are zero posts remaining

jQuery.fn.almDone = function(){
    if (!jQuery("#alm_listing_message").hasClass("js-m-listing__message--isactive")) { // Only show message if another hasn't already been shown e.g. by almEmpty()
        jQuery("#alm_listing_message p").text(jQuery("#alm_listing_message").attr("data-done"));
        jQuery("#alm_listing_message").addClass("js-m-listing__message--isactive");
    }
};

// almEmpty() is dispatched when zero results are returned in the initial Ajax Load More query

jQuery.fn.almEmpty = function(){
    jQuery("#alm_listing_message p").text(jQuery("#alm_listing_message").attr("data-empty"));
    jQuery("#alm_listing_message").addClass("js-m-listing__message--isactive");
};